<template>
  <div class="hello">
    <section class="main_section" v-bind:class="{ 'pic--1': true }"></section>

    <section class="menu-nav">
      <v-btn flat large :class="{ 'active': page === 1 }" v-on:click.native="goPage(1)">活動介紹</v-btn> |
      <v-btn flat large :class="{ 'active': page === 2 }" v-on:click.native="goPage(2)">活動獎項</v-btn> |
      <v-btn flat large :class="{ 'active': page === 3 }" v-on:click.native="goPage(3)">使用說明</v-btn> |
      <v-btn flat large :class="{ 'active': page === 4 }" v-on:click.native="goPage(4)">抽獎說明</v-btn> |
      <v-btn flat large :class="{ 'active': page === 5 }" v-on:click.native="goPage(5)">注意事項</v-btn> |
      <v-btn flat large :class="{ 'active': page === 6 }" v-on:click.native="goPage(6)">得獎公告</v-btn>
    </section>

    <section class="content" v-if="page == 1">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <strong>活動期間</strong><p>2018/7/20~2018/10/15</p>
          <strong>參加對象</strong>
          <ol class="ml-5">
            <li>一般民眾，註冊成為LiveABC官網會員後可使用。</li>
            <li>新北市小學/國中/高中學生，可透過新北市親師生平台帳號登入。</li>
          </ol>

          <strong>活動方式</strong>
          <ol class="ml-5">
            <li>於活動期間內，登入遊新北學英語APP。</li>
            <li>完成每日任務、指定打卡、累積登入任一條件，即可獲得來福幣點數。</li>
            <li>使用來福幣點數兌換抽獎券，即有機會抽中活動獎項。</li>
          </ol>

          <strong>立即下載</strong>
          <v-row class="text-xs-center">
            <v-col sm4 offset-sm2>
              <img src="~../assets/events/summer2018/ntc4g-apple.png" width="50%"><br>
              <a href="https://itunes.apple.com/tw/app/%E6%96%B0%E5%8C%97%E5%B8%82%E8%8B%B1%E8%AA%9E%E6%99%BA%E6%85%A7%E5%9F%8E/id1337959562?mt=8" target="_blank">
                <img src="~../assets/images/icon_02.png" />
              </a>
            </v-col>
            <v-col sm4>
              <img src="~../assets/events/summer2018/ntc4g-google.png" width="50%"><br>
              <a href="https://play.google.com/store/apps/details?id=com.liveabc.ntc4g" target="_blank">
                <img src="~../assets/images/icon_03.png" />
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <section class="content" v-if="page == 2">
      <v-row class="text-xs-left">
        <v-col md10 offset-md1 xs12 pa-3>
          <table class="table" v-if="!authorized">
            <tr>
              <td>頭獎</td>
              <td>SONY DSC-WX500數位相機</td>
              <td>價值10,980元</td>
              <td>1名</td>
            </tr>
            <tr>
              <td>貳獎</td>
              <td>Apple iPad 32G wifi</td>
              <td>價值10,900元</td>
              <td>1名</td>
            </tr>
            <tr>
              <td>參獎</td>
              <td>ASUS ROG Strix Fusion 300 電競耳機</td>
              <td>價值3,590元</td>
              <td>1名</td>
            </tr>
            <tr>
              <td>肆獎</td>
              <td>《圖解生活英語》點讀套書</td>
              <td>價值2,590元</td>
              <td>2套</td>
            </tr>
            <tr>
              <td>伍獎</td>
              <td>《知識大圖解》雜誌12期</td>
              <td>價值1,990元</td>
              <td>5名</td>
            </tr>
          </table>

          <div v-else>
            <p class="text-xs-right">來福幣：{{ coin }}</p>
            <table class="table">
              <tr v-for="award in awards">
                <td>{{ award.prize }}</td>
                <td>{{ award.item }}</td>
                <td style="width: 200px">持有 {{ award.userTickectCount }} 張抽獎卷</td>
              </tr>
            </table>
          </div>

          <p class="text-xs-center mt-5" v-if="!authorized">
            登入「遊新北學英語」APP，可查詢來福幣數量與抽獎券資訊。<br>
            <v-btn primary v-on:click.native="login()">登入</v-btn>
          </p>
        </v-col>
      </v-row>
    </section>

    <section class="content" v-if="page == 3">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <strong>獎勵內容</strong>
          <ol class="ml-5">
            <li>於活動期間內完成每日任務、指定打卡、累積登入任一條件，即可獲得任務獎勵。</li>
            <li>請於指定期限內領取任務獎勵－來福幣，一經過期，恕無法領取來福幣。</li>
          </ol>

          <strong>獲得任務獎勵方法如下：</strong>

          <v-row class="img-text">
            <v-col sm12>
              I. 完成每日任務
              <p class="text-xs-center pb-3">1. 每日登入：每日登入遊新北學英語APP</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-1/1-1.jpg">
              <p>進入學習地圖，完成每日登入。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-1/1-2.jpg">
              <p>於每日任務，點選 [領取]。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-1/1-3.jpg">
              <p>點選 [確定] 完成領取。</p>
            </v-col>
          </v-row>

          <hr>

          <v-row class="img-text">
            <v-col sm12 class="text-xs-center">
              <p class="text-xs-center pb-3">2. 完成每日指定學習點簡介/會話/圖解課程測驗</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-1.jpg">
              <p>於每日任務，點選指定學習點項目，點選[前往]。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-2.jpg">
              <p>參考指定學習點項目，點選地圖上的學習樹。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-3.jpg">
              <p>點選指定的學習課程。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-4.jpg">
              <p>看完簡介影片、會話影片或圖解單字課程，點選右下角的[工具]按鈕。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-5.jpg">
              <p>完成課後練習，並答對所有題目。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-6.jpg">
              <p>點選[繼續探索]，完成指定的學習項目。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-7.jpg">
              <p>於每日任務，點選 [領取]。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-2/2-8.jpg">
              <p>點選 [確定] 完成領取。</p>
            </v-col>
          </v-row>

          <hr>

          <v-row class="img-text">
            <v-col sm12>
              II. 完成指定打卡
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-1.jpg">
              <p>參考指定打卡清單</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-2.jpg">
              <p>抵達現場，點選地圖上的指定學習樹。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-3.jpg">
              <p>點選 [請打卡]。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-4.jpg">
              <p>於現場找到提示圖片，系統將透過AR技術進行辨識。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-5.jpg">
              <p>完成學習點打卡，點選 [X] 離開。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-6.jpg">
              <p>於每日任務，點選 [領取]。</p>
            </v-col>
            <v-col md4 xs12 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-3/3-7.jpg">
              <p>點選 [確定] 完成領取。</p>
            </v-col>
          </v-row>

          <hr>

          <v-row>
            <v-col sm12>
              III. 完成累積登入<br>
              活動期間，累積登入5/10/20/40/50天，即可獲得任務獎勵。
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <section class="content" v-if="page == 4">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <strong>抽獎說明</strong>
          <ol class="ml-5">
            <li>於活動期間內使用來福幣兌換抽獎券，即可參加抽獎贏得大獎。</li>
            <li>每參與一次抽獎，兌換當下即需扣除10~100點來福幣點數，一旦參與抽獎，即無法取消參與紀錄亦無法退還點數。</li>
            <li>使用來福幣兌換抽獎券，請詳細閱讀完活動連結內完整注意事項，並於當下完成扣點，成功扣點者始符合本活動抽獎資格，並獲得1次抽獎資格，抽獎不保證中獎。每人每日不限參加次數，每人僅限中獎一次，請確認您的來福幣點數是否充足；來福幣剩餘點數不足，無法成功完成扣點者，視同放棄本活動抽獎資格，恕不另行通知。</li>
            <li>2018/10/19由系統隨機抽出幸運得獎者，2018/10/25前公告中獎名單於官方網站。</li>
          </ol>
          <v-row class="img-text mt-5">
            <v-col xs12 md4 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-5/5-1.jpg">
              <p>開啟遊新北學英語 APP，點選活動圖示。</p>
            </v-col>
            <v-col xs12 md4 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-5/5-2.jpg">
              <p>點選 [來福幣抽獎]，確認兌換項目並詳閱注意事項，點選 [點數] 按鈕進行兌換。</p>
            </v-col>
            <v-col xs12 md4 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-5/5-3.jpg">
              <p>瀏覽活動條件，並勾選「我已觀看並同意活動條款」，點選 [同意活動條款]。</p>
            </v-col>
            <v-col xs12 md4 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-5/5-4.jpg">
              <p>再次確認兌換資訊，點選 [兌換] 按鈕]。</p>
            </v-col>
            <v-col xs12 md4 class="text-xs-center">
              <img src="~../assets/events/summer2018/app_screen/section-5/5-5.jpg">
              <p>成功獲得抽獎資格1次。</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <section class="content" v-if="page == 5">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <strong>一、活動贈獎辦法：</strong>

          <ol class="ml-5 mb-5">
            <li>參加者於參加本活動之同時，即同意接受本活動之活動辦法與注意事項之規範，如有違反活動相關規範，即自動喪失本活動參加資格，如為得獎者，則喪失得獎資格。</li>
            <li>獎項及領獎程序
              <div class="pl-5">
                <ol type="a">
                  <li>得獎通知：凡活動得獎者，希伯崙股份有限公司（以下簡稱本公司）將於<span style="color: red">2018年10月25日前</span>公布於<span style="color: red">「新北市英語智慧城」官方網站及Facebook粉絲團，並寄發中獎通知email</span>，請活動參加者注意網站公告及電子信箱。</li>
                  <li>準中獎人若經檢查發現資格或身分不符或資料為偽造變造者，本公司將取消得獎者資格；準中獎人若未依規定於領獎資格確認期間內（以郵戳為憑）自行列印及填妥中獎通知書後寄回希伯崙股份有限公司，或因個人資料填寫錯誤導致無法聯絡者，或領獎時未能出具上述資料者，皆視同放棄得獎權益。中獎者若因會員資料（姓名、電話、地址）不全或有誤，導致活動小組無法連絡通知者，本公司有權予以取消中獎者之權利。</li>
                  <li>中獎者未提供或提供不實個人基本資料，視同放棄得獎權利並自負其責。若未於指定時間內完成兌獎程序，即視同放棄獎項，恕不補發獎項。</li>
                </ol>
              </div>
            <li>本公司保留修改及終止本活動與獎項細節之權利，無須事前通知，並有權對本活動所有事宜作出解釋或裁決。</li>
            <li>本公司有權檢視各活動參加者之活動參與行為及中獎情形是否涉嫌以任何其他不正當的方式意圖以進行不實或虛偽活動參與行為，活動參加者因上述情形所獲得之活動資格及獎額，本公司保有取消得獎資格的權利，並保留法律追訴權。</li>
            <li>參加活動者若以惡意程式、竄改紀錄或違反法律或其他非法之方式違反本活動之公平性或正確性，或意圖混淆、影響本活動結果者，經本公司發現或經第三人檢舉，本公司除得取消其中獎資格外，並得追回獎項。參加活動者應自行承擔因違反相關規定所生之一切法律責任。</li>
            <li>贈品不得轉換現金，獎項以實體為主。</li>
            <li>參加活動者即表示同意並遵守本公司的活動公告，如有違反，即喪失參加活動資格。</li>
            <li>中獎人若未滿20歲，且依法規定需提戶口名簿備查。</li>
            <li>如因不可抗拒之事由導致獎品內容變更，中獎人同意接受本公司所安排之等值替代獎品，中獎者不得要求折現或轉換其他商品，亦不得轉讓獎品給他人。</li>
            <li>本活動所有抽獎與兌換贈品，僅限郵寄至臺、澎、金、馬地區，但因商品特性或材質無法郵寄者，不在此限。</li>
            <li>依中華民國稅法規定，贈品價值超過新台幣1,000元，須計入個人所得稅計算。</li>
            <li>主辦單位：希伯崙股份有限公司。</li>
            <li>得獎者務必保留郵寄憑證，避免影響兌獎權益。</li>
          </ol>

          <strong>二、參加者個人資料使用條款：</strong>
          <ol class="ml-5">
            <li>參加者同意希伯崙股份有限公司，依照個人資料保護法之規定，基於「新北市英語智慧城」網站抽獎活動（下稱本活動）之執行、蒐集、處理並利用參加者所提供之個人資料（含姓名、電子郵件信箱、電話、地址），截至參加者主動請求本公司刪除、停止處理或利用其個人資料為止。</li>
            <li>參加者所提供的個人資料，將用於提供本公司寄送確認信件、確認身份等與本活動有關之事宜使用。參加者有權得隨時請求本公司查閱、給予複本、或補正本人的個人資料，亦得隨時洽本公司表示拒絕本公司繼續蒐集、處理、利用或刪除本人的個人資料；惟本公司因執行本活動所必要者，則不在此限。若參加者不提供提供錯誤之個人資料，本公司將取消參加者之參加或得獎資格。</li>
            <li>當您參加此抽獎活動即成為本公司會員並永久享有會員權益，並同意下列條款：為提供更好服務，希伯崙股份有限公司或關係企業或合作對象，於業務推展之必要範圍內及業務推廣期間及地域內，得使用本人所提供之個人資料（包括個人姓名、出生年月日、教育、職業、地址、email、聯絡方式等），並得以（包括但不限於）發送廣告、活動訊息、電話行銷等通知您相關訊息。除本人有反對表示，希伯崙股份有限公司得於本刊發行期間及地區內（與會員有效期間同），利用本人所提供之個人資料。希伯崙股份有限公司對所蒐集之資料依法有保密義務。本人有隨時求停止蒐集、處理、利用或請求刪除之權利。</li>
            <li>有關本活動個人資料保護之事項，如需聯絡請洽：<a href="mailto:service@liveabc.com">service@liveabc.com</a></li>
          </ol>
        </v-col>
      </v-row>
    </section>

    <section class="content" v-if="page == 6">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <p class="text-xs-center">
            <video src="/ntc/static/20181023.mp4" width="80%" controls></video>
          </p>

          <p><strong>2018/10/19由系統隨機抽出幸運得獎者，2018/10/25前公告中獎名單於官方網站。</strong></p>

          <strong>中獎說明：</strong>

          <ol class="ml-5">
            <li>參加活動者務必填寫正確E-mail信箱，並同步密切注意中獎名單。</li>
            <li>得獎者請於2018/10/30前與主辦單位聯繫回覆，以免錯過得獎權利。</li>
            <li>活動所取得之個人資料僅限抽獎活動使用，不做其他用途。</li>
          </ol>

          <strong>獎項寄送：</strong>
          <p>各獎項將於確認各得獎者身份後2週後陸續寄送。</p>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import api from '../api'
export default {

  name: 'Event',

  data () {
    return {
      page: 1,
      coin: 0,
      awards: [],
      eventId: ''
    }
  },

  mounted () {
    this.eventId = this.$route.params.eventId
    this.page = this.$route.query.page || 1

    if (this.authorized) {
      this.getData()
    }
  },

  methods: {
    goPage (page) {
      this.page = page
    },

    login () {
      this.$router.push('/login?ref=/event/2018Summer?page=2')
    },

    getData () {
      let self = this

      api.Event.RecordSummary(this.eventId)
        .then((res) => {
          self.coin = res.data.data.rewardNum
        })
      api.Event.Award(this.eventId)
        .then((res) => {
          self.awards = res.data.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    position: relative;
    text-align: center;
    color: #fff;
  }

  .main_section {
    height: 45vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 0%;

    &.pic--1 {
      background-image: url('~../assets/events/summer2018/pic_summer_banner.jpg');
    }
  }

  .menu-nav {
    text-align: center;
    font-size: 1.3em;
    background-color: #fff;
    color: #000;
    padding: 1.5em;

    .active {
      color: #ccc;
    }
  }

  .content {
    background-color: #e9e8f0;
    color: #000;
    padding: 3em 5em 5em 5em;
    text-align: left;
    font-size: 1.2em;
    line-height: 250%;
    letter-spacing: 3px;

    @media screen and (max-width: 768px) {
      font-size: 1em;
      line-height: 200%;
      letter-spacing: normal;
      padding: 1em 2em 2em 2em;
    }
  }

  .table {
    line-height: 200%;
    background-color: #fff;
    td {
      padding: 1em;
    }

    td:first-child {
      background-color: #885eb2;
      text-align: center;
      color: #fff;
      font-weight: 900;
      font-size: 1.4em;
    }

    td:last-child {
      background-color: #ccc;
      text-align: center;
      width: 140px;
    }
  }

  hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .img-text {
    img {
      max-width: 75%;
      max-height: 300px;
    }

    p {
      width: 75%;
      margin: auto;
      text-align: left;
      line-height: 120%;
      letter-spacing: normal;
      margin-bottom: 3em;
      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// 2018Summer.vue?08e9ac59